export const numberToDisplayString = (
  input: number | string,
  options: Intl.NumberFormatOptions = {},
) => {
  if (Number.isNaN(input)) return 'N/A';
  if (!input && input !== 0) return '';

  return Number(input).toLocaleString(undefined, options);
};
